// @dynamic-i18n-keys
// Dynamic t() at line 17 (errorName from ErrorNames):
//   searchPage.emptyState.title.none
//   searchPage.emptyState.title.request
//   searchPage.emptyState.title.highOffset
//   searchPage.emptyState.title.noResults
//   searchPage.emptyState.title.pastEndOfResults
//   searchPage.emptyState.title.allMature
//   searchPage.emptyState.title.allStored
//   searchPage.emptyState.title.allDeleted
//   searchPage.emptyState.title.allAntisocial
//   searchPage.emptyState.title.highLoad
//   searchPage.emptyState.title.allBlocked
//   searchPage.emptyState.title.noDeviantsYouWatch
//   searchPage.emptyState.title.tagBlocked
//   facetPage.emptyState.title
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import EmptyResultError from './EmptyResultError';
import { ErrorNames } from '../../../constants';

import s from './EmptyResult.scss';

export interface Props {
  errorName: ErrorNames;
}

const EmptyResultDueToSettings: FC<Props> = ({ errorName }) => {
  const { t } = useTranslation();
  return (
    <div className={s['empty-state-root']}>
      <div className={s['empty-state-label']}>
        {t([`searchPage.emptyState.title.${errorName}`, 'facetPage.emptyState.title'])}
      </div>
      <div className={s['empty-state-error']}>
        <EmptyResultError errorName={errorName} />
      </div>
    </div>
  );
};
EmptyResultDueToSettings.displayName = 'EmptyResultDueToSettings';

export default EmptyResultDueToSettings;
